module.exports = __webpack_public_path__ + "static/media/speciality.44016bd0.png";